import initialState from './initialState';
import { types } from './actions';
import * as Constants from '../../../../../HelperMethods/constants';

export default function engineLogViewReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOADING_ALL_RUN_ENGINE_HISTORY: {
      return { ...state, rowData: [], isPageLoading: true, users: [] };
    }
    case types.LOADED_ALL_RUN_ENGINE_HISTORY_SUCCESSFULLY: {
      return {
        ...state,
        rowData: action.response.data.getRouteEngineHistoryByField.items,
        nextToken: action.response.data.getRouteEngineHistoryByField.nextToken,
        isPageLoading: false,
        users: action.users,
      };
    }
    case types.LOADING_ALL_RUN_ENGINE_HISTORY_FAILED: {
      return { ...state, rowData: [], isPageLoading: false, nextToken: null };
    }
    case types.LOAD_ALL_LOGS_PAGE_VIEW: {
      return { ...state, currentView: Constants.ENGINE_LOGS_VIEW.ENGINE_ALL_LOGS_VIEW };
    }
    case types.LOAD_SINGLE_LOG_PAGE_VIEW: {
      return {
        ...state,
        currentView: Constants.ENGINE_LOGS_VIEW.ENGINE_SINGLE_LOG_VIEW,
        selectedLog: action.routeEngineData,
      };
    }
    default:
      return state;
  }
}
